import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "submitButton"]

  connect() {
    this.adjustHeight()
    this.textareaTarget.focus()
  }

  clearForm() {
    this.textareaTarget.value = ""
    this.adjustHeight()
    this.textareaTarget.focus()
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      const textarea = this.textareaTarget
      if (textarea.value.trim() !== "") {
        this.submitButtonTarget.click()
      }
    }
  }

  adjustHeight() {
    const textarea = this.textareaTarget
    textarea.style.height = 'auto'
    textarea.style.height = Math.min(textarea.scrollHeight, 128) + 'px' // max 8rem
    
    // Enable/disable submit button based on content
    const hasContent = textarea.value.trim() !== ""
    this.submitButtonTarget.disabled = !hasContent
  }
}
